import { makeStyles } from '@material-ui/core/styles';

// Palete de colors aqui: https://material-ui.com/customization/palette/

import { spinnerLoadingColor } from '../utils/constants';

export const backdrop = makeStyles((theme) => ({
  spinnerLoading: {
    zIndex: theme.zIndex.drawer + 1,
    color: spinnerLoadingColor,
  },
}));
